import { useGetQuery } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { uniq } from "lodash";
import { z } from "zod";

const msaResponseSchema = z.array(
  z.object({
    name: z.string(),
  })
);

export function useGetMSAs() {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/msa`,
    responseSchema: msaResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_MSAS_FAILURE,
    },
    select: (data) => uniq(data.map((msa) => msa.name)),
  });
}
